import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute, Data, Router } from '@angular/router'

import { Observable, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { MoniyritystukiComponentData } from 'app/_angular/_resolvers/moniyritystuki.resolve'
import { DebugService } from 'app/_angular/service/debug.service'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { Moniyritystuki } from 'app/_jaettu-lemonator/model/moniyritys'

interface OsallinenRivi {
  kayttajaAvain: string
  asiakasAvain: string
  asiakasNimi: string
  ytunnus: string
  etunimi: string
  sukunimi: string
  email: string
}

interface DebugLinkki {
  otsikko: string
  uri: string
  encodedUri: string
}

@Component({
  templateUrl: './moniyritystuki.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MoniyritystukiComponent implements OnInit, OnDestroy {
  private _ngUnsubscribe = new Subject<void>()

  tuki: Moniyritystuki | null = null
  osalliset: OsallinenRivi[] = []

  kirjanpitajaOnDevaajaObservable: Observable<boolean>
  debugLinkitLemonator: DebugLinkki[] = []
  debugLinkitLemonaid: DebugLinkki[] = []

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _debugService: DebugService,
  ) {}

  ngOnInit() {
    this.kirjanpitajaOnDevaajaObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaObservable

    this._route.data.pipe(takeUntil(this._ngUnsubscribe)).subscribe((data: Data) => {
      const componentData = data.data as MoniyritystukiComponentData
      this.tuki = componentData.tuki
      this._luoDebugLinkit(componentData.tuki)
      this.osalliset = (componentData.tuki?.osalliset ?? []).map(osallinen => ({
        kayttajaAvain: osallinen.kayttajaAvain,
        asiakasAvain: osallinen.asiakasAvain,
        asiakasNimi: osallinen.asiakasNimi,
        ytunnus: osallinen.ytunnus,
        etunimi: osallinen.etunimi,
        sukunimi: osallinen.sukunimi,
        email: osallinen.email,
      }))
    })
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  takaisin() {
    this._router.navigate(['yllapito', 'moniyritystuet'])
  }

  private _luoDebugLinkit(tuki: Moniyritystuki | null) {
    this.debugLinkitLemonator = []
    this.debugLinkitLemonaid = []
    if (!tuki?.avain) {
      return
    }
    const tukiUri = `moniyritystuet/${tuki.avain}`
    const historiatUri = `${tukiUri}/moniyritystuki-historiat`
    this.debugLinkitLemonator.push(
      { otsikko: 'Tuki', uri: tukiUri, encodedUri: this._debugService.createFirestoreLink(tukiUri) },
      { otsikko: 'Historia', uri: historiatUri, encodedUri: this._debugService.createFirestoreLink(historiatUri) },
    )
    for (const osallinen of tuki.osalliset ?? []) {
      const replikaUri = `asiakkaat/${osallinen.asiakasAvain}/kayttajat/${osallinen.kayttajaAvain}/moniyritystuki/${tuki.avain}`
      this.debugLinkitLemonator.push({
        otsikko: `Replika ${osallinen.etunimi} ${osallinen.sukunimi} / ${osallinen.asiakasNimi}`,
        uri: replikaUri,
        encodedUri: this._debugService.createFirestoreLink(replikaUri),
      })
    }
    for (const osallinen of tuki.osalliset ?? []) {
      const moniyritystiedotUri = `kayttajan-moniyritystiedot/${osallinen.kayttajaAvain}`
      this.debugLinkitLemonaid.push({
        otsikko: `Moniyritystiedot ${osallinen.etunimi} ${osallinen.sukunimi}`,
        uri: moniyritystiedotUri,
        encodedUri: this._debugService.createFirestoreLinkLemonaid(moniyritystiedotUri),
      })
    }
  }
}
